import { render, staticRenderFns } from "./SelectDataComponent.vue?vue&type=template&id=5e0b1b52"
import script from "./SelectDataComponent.vue?vue&type=script&lang=js"
export * from "./SelectDataComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectDataComponent.vue?vue&type=style&index=0&id=5e0b1b52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports